/** Matches server `LeadNoteViewModel` (CRM `ClientNote` + author display name). */
export interface LeadNote {
  Id: number;
  /** Owning client; present on notes from GetLead / GetClient. */
  ClientId?: number;
  /** Set when tied to a lead; null/undefined for client-only rows. */
  LeadId?: number | null;
  Note: string;
  CreatedDate: Date | string;
  UserId?: number;
  /** Display name for the author when resolved by the server. */
  UserName?: string | null;
  GpsLongitude?: string;
  GpsLatitude?: string;
}

/** Stable key for `v-for` lists. */
export function leadNoteStableKey(note: LeadNote): string {
  return `${note.Id}-${note.ClientId ?? 0}-${note.LeadId ?? "c"}`;
}
